import type { I18nContext } from '~marketing/types/i18n-context';

/**
 * Client-only: the locale and catalogue ~marketing/client loads before
 * hydrating. The client counterpart of ~marketing/i18n-storage.
 */
export const i18nClientStore: { context?: I18nContext } = {};
